import type { EnergyProfile } from './energy';

export type VehicleProfile = EnergyProfile & {
  dcConnector: 'ccs2' | 'chademo';
  maxDcChargeKw: number;
  vehicleBrand: 'unknown' | 'tesla' | 'other';
};

export const DEFAULT_VEHICLE_PROFILE: VehicleProfile = {
  batteryKwh: 60,
  consumptionWhKm: 170,
  marginPct: 15,
  minArrivalSocPct: 10,
  dcConnector: 'ccs2',
  maxDcChargeKw: 50,
  vehicleBrand: 'unknown',
};

export async function fetchVehicleProfile(signal?: AbortSignal): Promise<VehicleProfile | null> {
  const response = await fetch('/v1/vehicle-profile', {
    credentials: 'include', cache: 'no-store', signal,
  });
  const json = await response.json();
  if (!response.ok || !json.ok) throw new Error('A járműprofil nem tölthető be.');
  return json.data ?? null;
}

export async function saveVehicleProfile(profile: VehicleProfile): Promise<VehicleProfile> {
  const response = await fetch('/v1/vehicle-profile', {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profile),
  });
  const json = await response.json();
  if (!response.ok || !json.ok || !json.data) {
    throw new Error(response.status === 401 ? 'A mentéshez jelentkezz be újra.' : 'A járműprofil mentése sikertelen.');
  }
  return json.data;
}
